import { Component, uiElement, uiElements, uiEvent } from "@kluntje/core";
import { addClass, hasClass, removeClass, toggleClass, waitFor } from "@kluntje/js-utils/lib/dom-helpers";
import { WECLazyImage } from "Components/wec-e-lazy-image/wec-e-lazy-image";
import { ACTIVE, DISABLED, OPEN } from "Constants/cssClasses";
import FocusService from "Services/FocusService";
import ScrollLockService from "Services/ScrollLockService";

export class WECImageGalleryLightbox extends Component {
  @uiElements(".wec-m-image-gallery-lightbox__image")
  images: Array<WECLazyImage>;

  @uiElement(".wec-m-image-gallery-lightbox__closing-btn")
  closingBtn: HTMLButtonElement;

  @uiElement(".wec-m-image-gallery-lightbox__nav-btn--prev")
  prevBtn: HTMLButtonElement;

  @uiElement(".wec-m-image-gallery-lightbox__nav-btn--next")
  nextBtn: HTMLButtonElement;

  afterComponentRender() {
    const activeImageId = this.activeImageId;
    addClass(this.images[activeImageId], ACTIVE);
    this.updateNavBtnStates();
  }

  get activeImageId() {
    const activeImageId = this.images.findIndex(image => hasClass(image, ACTIVE));

    if (activeImageId === -1) return 0;

    return activeImageId;
  }

  set activeImageId(newValue) {
    const activeImageId = this.activeImageId;
    if (newValue < 0 || newValue >= this.images.length || activeImageId === newValue) return;

    removeClass(this.images[activeImageId], ACTIVE);
    addClass(this.images[newValue], ACTIVE);
    this.updateNavBtnStates();
  }

  @uiEvent("prevBtn", "click")
  handlePrevBtnClick() {
    this.activeImageId -= 1;
  }

  @uiEvent("nextBtn", "click")
  handleNextBtnClick() {
    this.activeImageId += 1;
  }

  updateNavBtnStates() {
    const activeImageId = this.activeImageId;

    toggleClass(this.prevBtn, DISABLED, activeImageId === 0);
    toggleClass(this.nextBtn, DISABLED, activeImageId === this.images.length - 1);
  }

  @uiEvent("this", "click")
  handleOutsideClick(e: MouseEvent) {
    if (e.target === this) this.close();
  }

  open() {
    addClass(this, OPEN);
    FocusService.trapFocusIn(this);
    ScrollLockService.lockPage();
  }

  @uiEvent("closingBtn", "click")
  async close() {
    removeClass(this, OPEN);
    FocusService.unTrapFocusIn(this);
    ScrollLockService.unlockPage();
    await waitFor(150);
    this.remove();
  }
}

customElements.define("wec-m-image-gallery-lightbox", WECImageGalleryLightbox);
